var KMosaicElementSize;
(function (KMosaicElementSize) {
    KMosaicElementSize["S"] = "S";
    KMosaicElementSize["M"] = "M";
    KMosaicElementSize["L"] = "L";
    KMosaicElementSize["XL"] = "XL";
})(KMosaicElementSize || (KMosaicElementSize = {}));
var KMosaicAnimationType;
(function (KMosaicAnimationType) {
    KMosaicAnimationType["NoAnimation"] = "NO_ANIMATION";
    KMosaicAnimationType["ZoomOnHover"] = "ZOOM_ON_HOVER";
})(KMosaicAnimationType || (KMosaicAnimationType = {}));
var KMosaicVerticalTextAlignType;
(function (KMosaicVerticalTextAlignType) {
    KMosaicVerticalTextAlignType["Center"] = "CENTER";
    KMosaicVerticalTextAlignType["Bottom"] = "BOTTOM";
    KMosaicVerticalTextAlignType["Top"] = "TOP";
    KMosaicVerticalTextAlignType["UnderMosaic"] = "UNDER_MOSAIC";
})(KMosaicVerticalTextAlignType || (KMosaicVerticalTextAlignType = {}));
var KMosaicHorizontalTextAlignType;
(function (KMosaicHorizontalTextAlignType) {
    KMosaicHorizontalTextAlignType["Center"] = "CENTER";
    KMosaicHorizontalTextAlignType["Left"] = "LEFT";
    KMosaicHorizontalTextAlignType["Right"] = "RIGHT";
})(KMosaicHorizontalTextAlignType || (KMosaicHorizontalTextAlignType = {}));
var KMosaicTextBackgroundType;
(function (KMosaicTextBackgroundType) {
    KMosaicTextBackgroundType["NoBackground"] = "NO_BACKGROUND";
    KMosaicTextBackgroundType["TopEffect"] = "TOP_EFFECT";
    KMosaicTextBackgroundType["BottomEffect"] = "BOTTOM_EFFECT";
    KMosaicTextBackgroundType["Unicolor"] = "UNICOLOR";
})(KMosaicTextBackgroundType || (KMosaicTextBackgroundType = {}));
var LinkType;
(function (LinkType) {
    LinkType["Didomi"] = "DIDOMI";
    LinkType["Folder"] = "FOLDER";
    LinkType["Mail"] = "MAIL";
    LinkType["URL"] = "URL";
})(LinkType || (LinkType = {}));

export { KMosaicAnimationType, KMosaicElementSize, KMosaicHorizontalTextAlignType, KMosaicTextBackgroundType, KMosaicVerticalTextAlignType, LinkType };
//# sourceMappingURL=index.props.js.map
